/**
 * Shift allocation types that collect worker interest during a window and
 * award the shift when it closes, instead of first come, first served.
 *
 * Add any new interest-based type here so the worker app shows
 * "Show Interest" and the scheduler shows interested counts for it.
 */
import {
	LOCATION,
	PRIMARYJOB,
	SENIORITY,
	SKILLLEVEL,
	WCFIFO,
	WORKCENTER,
} from "../assets/constants";

export const INTEREST_ALLOCATION_TYPES: readonly string[] = [
	SENIORITY,
	WORKCENTER,
	WCFIFO,
	LOCATION,
	PRIMARYJOB,
	SKILLLEVEL,
];

export const isInterestAllocationType = (
	shiftAllocationType?: string | null
): boolean =>
	!!shiftAllocationType &&
	INTEREST_ALLOCATION_TYPES.includes(shiftAllocationType);
